import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Send www visitors to the canonical host so API calls and admin cookies stay same-origin.
const apiHost = new URL(process.env.REACT_APP_BACKEND_URL).hostname;
if (window.location.hostname === `www.${apiHost}`) {
  window.location.replace(`https://${apiHost}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
